
class BankMovementExtraCell extends UITableViewCell
{

}